import React, { useRef, useState } from 'react';
import styles from './ApplyFileUpload.module.css';
import Icon from '../../components/common/Icon/Icon';

/**
 * @component ApplyFileUpload
 * @description 파일 첨부 드래그&드롭 업로드 영역
 *
 * @param {File[]}   props.files         - 현재 선택된 파일 목록
 * @param {Function} props.onFilesChange - (files: File[]) => void
 */
function ApplyFileUpload({ files, onFilesChange }) {
  const inputRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const addFiles = (newFiles) => {
    const merged = [...files, ...Array.from(newFiles)];
    onFilesChange(merged);
  };

  const removeFile = (idx) => {
    onFilesChange(files.filter((_, i) => i !== idx));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    addFiles(e.dataTransfer.files);
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleInputChange = (e) => {
    addFiles(e.target.files);
    e.target.value = '';
  };

  return (
    <div>
      <div
        className={`${styles.uploadArea} ${isDragOver ? styles.dragOver : ''}`}
        onClick={handleClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      >
        <span className={styles.uploadIcon}>
          <Icon name="upload" size="24" />
        </span>
        <p className={styles.uploadText}>프로필 사진, 영상 자료 등 첨부하세요</p>
        <p className={styles.uploadHint}>클릭하거나 파일을 끌어다 놓으세요</p>
      </div>

      <input
        ref={inputRef}
        type="file"
        multiple
        accept="image/*,video/*,.pdf"
        className={styles.hiddenInput}
        onChange={handleInputChange}
      />

      {files.length > 0 && (
        <ul className={styles.fileList}>
          {files.map((file, idx) => (
            <li key={idx} className={styles.fileItem}>
              <span className={styles.fileName}>{file.name}</span>
              <button
                type="button"
                className={styles.fileRemove}
                onClick={() => removeFile(idx)}
                aria-label={`${file.name} 제거`}
              >
                <Icon name="close" size="14" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ApplyFileUpload;
